export default "__VITE_ASSET__edb878fa__"